export default __webpack_public_path__ + "static/media/Numbers2_08.694519aa.png";